import { render, staticRenderFns } from "./AdminUpdateCompany.vue?vue&type=template&id=d10cf18c&scoped=true&"
import script from "./AdminUpdateCompany.vue?vue&type=script&lang=ts&"
export * from "./AdminUpdateCompany.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUpdateCompany.vue?vue&type=style&index=0&id=d10cf18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10cf18c",
  null
  
)

export default component.exports